<template>
    <div class="container">
        <form-association
            :association="association"
            :association_id="association_id"
            :form_mode="form_mode"
            :form_view="form_view"
            @is-form-dirty="isFormDirty"
        />
    </div>
</template>

<script>
import FormAssociation from '@/components/forms/Association.vue';

export default {
    components: {
        FormAssociation,
    },
    data() {
        return {
            form_mode: 'init',
            form_view: 'association',
        };
    },
    props: {
        association: Object,
        association_id: null,
    },
    methods: {
        isFormDirty(is_dirty) {
            this.$emit('is-form-dirty', is_dirty);
        },
    },
};
</script>
